import React from 'react';
import { ConnexionButton as ConnexionButtonComponent } from '@unboared/design.all';
import { useConnexionInfos } from '~/utils/connexion_infos';

export const ConnexionButton = ({ size = 40 }: { size?: number }) => {
  const { showConnexionInfos, toggleShowConnexionInfos } = useConnexionInfos();
  return (
      <ConnexionButtonComponent size={size} onPress={toggleShowConnexionInfos} active={showConnexionInfos} />
  );
}